import { View } from 'react-native';
const SearchBar = View;
export default SearchBar;
//# sourceMappingURL=SearchBar.web.js.map